// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"MultiSelectDropdown_dropdownContainer__5WICD","label":"MultiSelectDropdown_label__Dlvtj"};